import {Helmet} from "react-helmet-async";

import {CheckoutContextProvider} from "@/components/context/CheckoutContext.tsx";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {CustomQuoteRequestForm} from "@/pages/billing/custom-quote-request/CustomQuoteRequestForm.tsx";

export const CustomQuoteRequestPage = () => {
  return (
    <ContentContainer title="Custom Quote Request">
      <Helmet>
        <title>Custom Quote Request</title>
      </Helmet>
      <UpErrorBoundary>
        <CheckoutContextProvider>
          <div className="row px-3">
            <div className="col-8 white-block white-block-border rounded p-4">
              <h3 className="mb-1 text-center">Submit for Custom Quote Request</h3>
              <span className="d-block text-center mb-4 text-center mt-2">Scheduled within 24 hours</span>
              <hr className="pulse-color-gray-500 my-4" />
              <CustomQuoteRequestForm />
            </div>
            <div className="col-4 p-4">
              <h2 className="fs-5 fw-medium mb-4">Experience Unparalleled Monitoring Tailored to Your Needs!</h2>
              <ul>
                <li>Tailored monitoring solutions designed to meet your unique requirements of any size and scale.</li>
                <li>Robust monitoring infrastructure capable of handling thousands of checks.</li>
                <li>Intelligent alert management system handling hundreds of alerts with precision.</li>
                <li>Flexible subaccount structures facilitating dozens of user subaccounts.</li>
                <li>Long-term engagement benefits through multi-year agreements.</li>
                <li>Significant cost savings through scaled discounting options.</li>
              </ul>
            </div>
          </div>
        </CheckoutContextProvider>
      </UpErrorBoundary>
    </ContentContainer>
  );
};
